module.exports = __webpack_public_path__ + "img/arm.faa08ab1.jpg";